var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "container container-small" },
      [
        _c("br"),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm pr-sm-0" }, [
            _c("div", { staticClass: "d-flex search-car-number-wrapper" }, [
              _c("div", { staticClass: "form-group search-car-number" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.carPlateFilter,
                      expression: "carPlateFilter",
                    },
                  ],
                  staticClass: "form-control mb-2",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("search_car_after_license_plate"),
                  },
                  domProps: { value: _vm.carPlateFilter },
                  on: {
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.loadOrders.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.carPlateFilter = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "button",
                {
                  staticClass: "main-btn",
                  on: {
                    click: function ($event) {
                      return _vm.loadOrders()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("search_car_button")))]
              ),
            ]),
          ]),
          _c("div", { staticClass: "col-sm pl-sm-0" }, [
            _c("div", { staticClass: "form-group mb-2 flex-sm-grow-1" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.orderStatusFilter,
                      expression: "orderStatusFilter",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.orderStatusFilter = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function ($event) {
                        return _vm.loadOrders()
                      },
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(_vm._s(_vm.$t("choose_status"))),
                  ]),
                  _vm._l(_vm.orderSts, function (status) {
                    return _c("option", { domProps: { value: status.stsID } }, [
                      _vm._v(_vm._s(status.name)),
                    ])
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
        _c(
          "ul",
          {
            staticClass: "nav nav-tabs d-flex",
            attrs: { id: "myTab", role: "tablist" },
          },
          [
            _c(
              "li",
              {
                staticClass: "nav-item flex-grow-1 text-center",
                attrs: { role: "presentation" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "nav-link active",
                    attrs: {
                      id: "vignettes-tab",
                      "data-toggle": "tab",
                      href: "#vignettes",
                      role: "tab",
                      "aria-controls": "vignettes",
                      "aria-selected": "true",
                    },
                    on: {
                      click: function ($event) {
                        _vm.tab = "erv"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$tc("vignetteWord", 2)))]
                ),
              ]
            ),
            _c(
              "li",
              {
                staticClass: "nav-item flex-grow-1 text-center",
                attrs: { role: "presentation" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    attrs: {
                      id: "toll-tab",
                      "data-toggle": "tab",
                      href: "#toll",
                      role: "tab",
                      "aria-controls": "toll",
                      "aria-selected": "false",
                    },
                    on: {
                      click: function ($event) {
                        _vm.tab = "toll"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$tc("tollWord", 1)))]
                ),
              ]
            ),
          ]
        ),
        _vm.device == "desktop"
          ? [
              _c("div", { staticClass: "row align-items-center mt-4" }, [
                _c("div", { staticClass: "col-sm-6 col-12" }, [
                  _vm.tab == "erv"
                    ? _c(
                        "button",
                        {
                          staticClass: "main-btn",
                          on: {
                            click: function ($event) {
                              return _vm.downloadOrderCsv("erv")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btn_export_all_orders")))]
                      )
                    : _vm._e(),
                  _vm.tab == "toll"
                    ? _c(
                        "button",
                        {
                          staticClass: "main-btn",
                          on: {
                            click: function ($event) {
                              return _vm.downloadOrderCsv("tpf")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("btn_export_all_orders")))]
                      )
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "col-sm-6 col-12 text-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "link",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.triggerReportControls()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("btn_report_emitted", {
                            type:
                              _vm.tab == "erv"
                                ? _vm.$tc("vignette", 2)
                                : _vm.$tc("passing", 2),
                          })
                        )
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm.showRaportControls
                ? _c("div", { staticClass: "row mt-0 mt-sm-4" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm col-12 mb-sm-0 mb-2" },
                      [
                        _vm.generateReportEmittedCsvAttempt &&
                        _vm.reportFromDate == null
                          ? _c("span", { staticClass: "invalid-feedback" }, [
                              _vm._v(" " + _vm._s(_vm.$t("mandatory")) + " "),
                            ])
                          : _vm._e(),
                        _c("datepicker", {
                          staticClass: "form-group",
                          class: {
                            "has-error":
                              _vm.generateReportEmittedCsvAttempt &&
                              _vm.reportFromDate == null,
                          },
                          attrs: {
                            id: "dp-start",
                            language: _vm.getDatepickerTranslationsObj(),
                            "disabled-dates": _vm.disabledDates,
                            "bootstrap-styling": true,
                            placeholder: _vm.$t("start_valability"),
                          },
                          model: {
                            value: _vm.reportFromDate,
                            callback: function ($$v) {
                              _vm.reportFromDate = $$v
                            },
                            expression: "reportFromDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-sm col-12 mb-sm-0 mb-2" },
                      [
                        _vm.generateReportEmittedCsvAttempt &&
                        _vm.reportToDate == null
                          ? _c("span", { staticClass: "invalid-feedback" }, [
                              _vm._v(" " + _vm._s(_vm.$t("mandatory")) + " "),
                            ])
                          : _vm._e(),
                        _c("datepicker", {
                          staticClass: "form-group",
                          class: {
                            "has-error":
                              _vm.generateReportEmittedCsvAttempt &&
                              _vm.reportToDate == null,
                          },
                          attrs: {
                            id: "dp-end",
                            language: _vm.getDatepickerTranslationsObj(),
                            "disabled-dates": _vm.disabledDates,
                            "bootstrap-styling": true,
                            placeholder: _vm.$t("end_valability"),
                          },
                          model: {
                            value: _vm.reportToDate,
                            callback: function ($$v) {
                              _vm.reportToDate = $$v
                            },
                            expression: "reportToDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "col-sm-4 col-12" }, [
                      _c(
                        "button",
                        {
                          staticClass: "main-btn",
                          on: {
                            click: function ($event) {
                              return _vm.generateReportEmittedCsv(_vm.tab)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("info_download_file")))]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          : _vm._e(),
        _vm.tab == "erv"
          ? _c("Pagination", {
              class: "no-plr",
              attrs: { page: _vm.page_erv, total: _vm.orders_vignette_total },
              on: {
                goToPage: function ($event) {
                  return _vm.setPage("erv", $event)
                },
              },
            })
          : _vm._e(),
        _vm.tab == "toll"
          ? _c("Pagination", {
              class: "no-plr",
              attrs: { page: _vm.page_tpf, total: _vm.orders_toll_total },
              on: {
                goToPage: function ($event) {
                  return _vm.setPage("tpf", $event)
                },
              },
            })
          : _vm._e(),
        _c("div", { staticClass: "orders-content" }, [
          _c("div", { staticClass: "tab-content", attrs: { id: "orders" } }, [
            _c(
              "div",
              {
                staticClass: "tab-pane fade show active",
                attrs: {
                  id: "vignettes",
                  role: "tabpanel",
                  "aria-labelledby": "vignettes-tab",
                },
              },
              [
                _vm.orders_vignette && !_vm.loading
                  ? [
                      _c("div", { staticClass: "header mt-md-4 top" }, [
                        _c("div", { staticClass: "header-pill name" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("order_header_name")) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "header-pill data" }, [
                          _vm._v(" " + _vm._s(_vm.$t("date")) + " "),
                        ]),
                        _c("div", { staticClass: "header-pill payment-type" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("order_header_payment_type")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "header-pill status" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("order_header_status")) + " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "header-pill total d-sm-block d-none",
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("total")) + " ")]
                        ),
                      ]),
                      _vm._l(_vm.orders_vignette, function (item, key) {
                        return _c(
                          "router-link",
                          {
                            key: key,
                            staticClass: "cart-item mt-sm-3",
                            attrs: {
                              to: {
                                name: "order",
                                params: { id: item.id, type: "vignette" },
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header bottom" }, [
                              _c("div", { staticClass: "header-pill name" }, [
                                _vm._v(" " + _vm._s(item.orderName)),
                                _c("br"),
                                _c(
                                  "span",
                                  { staticClass: "d-sm-none d-block" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (
                                          item.valueTotal +
                                          item.orderTotalLeiSMS
                                        ).toFixed(2)
                                      ) + " lei"
                                    ),
                                  ]
                                ),
                                item.mixed_order &&
                                item.orderStatus == 1 &&
                                !item.mixed_order.is_old
                                  ? _c(
                                      "div",
                                      { staticClass: "d-none d-sm-block" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "main-btn",
                                            attrs: {
                                              href:
                                                _vm.url + item.mixed_order.hash,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("continue_payment"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "header-pill data" }, [
                                _vm._v(" " + _vm._s(item.date) + " "),
                              ]),
                              _c(
                                "div",
                                { staticClass: "header-pill payment-type" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.payment_type
                                          ? item.payment_type.descriere
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "header-pill status" }, [
                                _vm._v(" " + _vm._s(item.status.name) + " "),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-pill total d-sm-block d-none",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (
                                          item.valueTotal +
                                          item.orderTotalLeiSMS
                                        ).toFixed(2)
                                      ) +
                                      " lei "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                    ]
                  : _vm._e(),
                !_vm.orders_vignette
                  ? _c(
                      "div",
                      { staticClass: "alert alert-info text-center mt-3" },
                      [_vm._v(" " + _vm._s(_vm.$t("no_placed_order")) + " ")]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "tab-pane fade",
                attrs: {
                  id: "toll",
                  role: "tabpanel",
                  "aria-labelledby": "toll-tab",
                },
              },
              [
                _vm.orders_toll && !_vm.loading
                  ? [
                      _c("div", { staticClass: "header mt-md-4 top" }, [
                        _c("div", { staticClass: "header-pill name" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("order_header_name")) + " "
                          ),
                        ]),
                        _c("div", { staticClass: "header-pill data" }, [
                          _vm._v(" " + _vm._s(_vm.$t("date")) + " "),
                        ]),
                        _c("div", { staticClass: "header-pill payment-type" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("order_header_payment_type")) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "header-pill status" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("order_header_status")) + " "
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "header-pill total d-sm-block d-none",
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("total")) + " ")]
                        ),
                      ]),
                      _vm._l(_vm.orders_toll, function (item, key) {
                        return _c(
                          "router-link",
                          {
                            key: key,
                            staticClass: "cart-item mt-sm-3",
                            attrs: {
                              to: {
                                name: "order",
                                params: { id: item.id, type: "toll" },
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "header bottom" }, [
                              _c("div", { staticClass: "header-pill name" }, [
                                _vm._v(" " + _vm._s(item.orderName)),
                                _c("br"),
                                _c(
                                  "span",
                                  { staticClass: "d-sm-none d-block" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (
                                          item.valueTotal +
                                          item.orderTotalLeiSMS
                                        ).toFixed(2)
                                      ) + " lei"
                                    ),
                                  ]
                                ),
                                item.mixed_order &&
                                item.orderStatus == 1 &&
                                !item.mixed_order.is_old
                                  ? _c(
                                      "div",
                                      { staticClass: "d-none d-sm-block" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass: "main-btn",
                                            attrs: {
                                              href:
                                                _vm.url + item.mixed_order.hash,
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("continue_payment"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c("div", { staticClass: "header-pill data" }, [
                                _vm._v(" " + _vm._s(item.date) + " "),
                              ]),
                              _c(
                                "div",
                                { staticClass: "header-pill payment-type" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        item.payment_type
                                          ? item.payment_type.descriere
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "header-pill status" }, [
                                _vm._v(" " + _vm._s(item.status.name) + " "),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "header-pill total d-sm-block d-none",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (
                                          item.valueTotal +
                                          item.orderTotalLeiSMS
                                        ).toFixed(2)
                                      ) +
                                      " lei "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      }),
                    ]
                  : _vm._e(),
                !_vm.orders_toll
                  ? _c(
                      "div",
                      { staticClass: "alert alert-info text-center mt-3" },
                      [_vm._v(" " + _vm._s(_vm.$t("no_placed_order")) + " ")]
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ],
      2
    ),
    _c("div", { staticClass: "container container-small mt-5 mt-sm-0" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("router-link", { attrs: { to: { name: "vignette" } } }, [
              _c(
                "button",
                {
                  staticClass: "btn-vignette btn btn-purple w-100",
                  attrs: { type: "submit" },
                },
                [_vm._v(_vm._s(_vm.$t("i_want_vignette")))]
              ),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12 col-sm-6" },
          [
            _c("router-link", { attrs: { to: { name: "toll" } } }, [
              _c(
                "button",
                {
                  staticClass: "btn-tpf btn btn-purple w-100",
                  attrs: { type: "submit" },
                },
                [_vm._v(_vm._s(_vm.$t("i_want_toll")))]
              ),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }